// extracted by mini-css-extract-plugin
export default {"notification-box":"NotificationBox_notification-box__vsqsD","container":"NotificationBox_container__ghaWp","cta":"NotificationBox_cta__DB5FM"};